<template>
  <div>
    <div class="space-y-8 divide-y divide-border">
      <BudgetsStatIncome :sum-fact="widgetData.incomeFact"
                         :sum-plan="widgetData.incomePlan"
                         :difference="widgetData.incomeSum"/>
      <BudgetsStatExpense :sum-fact="widgetData.expenseFact"
                          :sum-plan="widgetData.expensePlan"
                          :difference="widgetData.expenseSum"/>
    </div>
    <MyBudgetsPreview class="mt-8 mb-2"
                      :color="widgetData.color"
                      :days-passed="widgetData.daysPassed"
                      :show-days="false"
                      :money-spent="widgetData.moneySpent"/>
  </div>
</template>

<script>

import BudgetsStatIncome from "@/components/cabinet/Money/Budgets/BudgetsStat/BudgetsStatIncome";
import BudgetsStatExpense from "@/components/cabinet/Money/Budgets/BudgetsStat/BudgetsStatExpense";
import MyBudgetsPreview from "@/components/cabinet/Money/Dashboard/MyBudgets/MyBudgetsPreview/MyBudgetsPreview";
import {mapGetters} from "vuex";

export default {
  name: "BudgetsStat",
  components: {MyBudgetsPreview, BudgetsStatExpense, BudgetsStatIncome},
  computed: {
    ...mapGetters('space/budgets', ['widgetData']),
  }
}
</script>

<style scoped>

</style>